export default __webpack_public_path__ + "static/ProValue_4@992-18ab0756b6522d7f88ff738579358c70.webp";